import signature from "src/assets/images/authorized-signature.png";

export const AuthorizedSignature = () => (
  <img
    src={signature}
    alt="Authorized signature"
    className="student-receipt-signature"
  />
);
